import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageForm from "components/pageForm";
import Button from "components/button";
import EmptyStateCompany from "components/emptyState";
import SectionWrapper from "pages/createMission/components/SectionWrapper";
import TemplateCard from "pages/missionTemplates/components/TemplateCard";
import UseContext from "hooks/useContext";
import useModal from "components/modal/useModal";
import ApiDataBase from "server";
import { Plus } from "assets/icons";

const MissionTemplates = () => {
    const navigate = useNavigate();
    const { toggle } = useModal();
    const {
        missionTemplates,
        setMissionTemplates,
        refreshMissionTemplates,
        setPendingDeleteMissionTemplate,
        resetTemplateData,
        companyData,
    } = UseContext();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!companyData?._id) return;
        let cancelled = false;
        setIsLoading(true);
        ApiDataBase.getMissionTemplates(
            { idCompany: companyData._id },
            (res) => {
                if (cancelled) return;
                setMissionTemplates(res?.templates || []);
                setIsLoading(false);
            },
            (err) => {
                if (cancelled) return;
                console.error(err);
                toast.error("Impossible de charger les fiches de poste");
                setIsLoading(false);
            }
        );
        return () => {
            cancelled = true;
        };
    }, [
        refreshMissionTemplates,
        setMissionTemplates,
        companyData?._id,
    ]);

    const handleCreate = () => {
        resetTemplateData();
        navigate("/missionTemplates/create");
    };

    const handleEdit = (template) => {
        navigate(`/missionTemplates/edit/${template._id}`);
    };

    const handleDelete = (template) => {
        setPendingDeleteMissionTemplate(template);
        toggle("missionTemplate_delete");
    };

    const hasTemplates = missionTemplates && missionTemplates.length > 0;

    return (
        <PageForm>
            <div className="col-span-full">
                <div className="w-full mx-auto lg:w-[800px] px-6 py-8">
                    {isLoading ? (
                        <div className="flex flex-col gap-3">
                            {[1, 2, 3].map((i) => (
                                <div
                                    key={i}
                                    className="h-24 bg-gray-100 rounded-xl animate-pulse"
                                />
                            ))}
                        </div>
                    ) : hasTemplates ? (
                        <div className="flex flex-col gap-6 pb-24">
                            <SectionWrapper
                                title="Fiches de postes"
                                description="Liste de fiches de postes."
                            >
                                <div className="flex flex-col gap-3">
                                    {missionTemplates.map((template) => (
                                        <TemplateCard
                                            key={template._id}
                                            template={template}
                                            onEdit={handleEdit}
                                            onDelete={handleDelete}
                                        />
                                    ))}
                                </div>
                            </SectionWrapper>
                        </div>
                    ) : (
                        <EmptyStateCompany
                            type={"job_post_template"}
                            onAction={handleCreate}
                        />
                    )}
                </div>
            </div>
            {hasTemplates && (
                <div className="col-span-full">
                    <div className="fixed bottom-0 left-[80px] sidebar-expanded:left-64 2xl:left-64 right-0 bg-white border-t border-gray-100 z-20">
                        <div className="w-full mx-auto lg:w-[800px] px-6 py-4">
                            <div className="flex justify-end items-center gap-3">
                                <Button
                                    size={"LG"}
                                    color={"SECONDARY"}
                                    onClick={() => navigate("/dashboard")}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    size={"LG"}
                                    color={"PRIMARY"}
                                    onClick={handleCreate}
                                >
                                    <div className="flex items-center gap-2">
                                        <Plus wh={14} color={"#fff"} />
                                        <div>Créer un nouveau model</div>
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </PageForm>
    );
};

export default MissionTemplates;
